import { Check, X } from "lucide-react";

export default function Philosophy() {
  return (
    <section id="philosophy" className="relative py-20 lg:py-28" data-testid="philosophy-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.2em] text-sunlit-mute mb-4">My approach</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl text-sunlit-ink leading-tight">
            This is <span className="italic text-sunlit-gold">coaching</span>,
            <br /> not counselling.
          </h2>
          <p className="mt-6 text-base sm:text-lg text-sunlit-mute leading-relaxed">
            Counselling holds you while you process what already is. Coaching walks beside you while you decide what's next — and then helps you actually do it. Happiness, I believe, is a practice. It asks you to shift from inside out.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          <div className="rounded-3xl border border-sunlit-gold/40 bg-sunlit-cream p-8 lg:p-10 relative overflow-hidden" data-testid="philosophy-coaching-is">
            <div className="absolute -top-6 -right-6 h-24 w-24 rounded-full bg-sunlit-gold/20 blur-2xl" />
            <p className="text-xs uppercase tracking-widest text-sunlit-gold font-medium mb-4">
              Happiness coaching IS
            </p>
            <ul className="space-y-4">
              {[
                "A willingness to look honestly at yourself",
                "Active inner-work between our sessions",
                "Small, repeatable shifts you carry for life",
                "A partnership — I guide, you walk",
              ].map((t) => (
                <li key={t} className="flex items-start gap-3 text-sunlit-ink">
                  <span className="mt-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-sunlit-gold/30">
                    <Check className="h-3 w-3 text-sunlit-ink" strokeWidth={3} />
                  </span>
                  <span className="text-base">{t}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-3xl border border-stone-200 bg-sunlit-ivory p-8 lg:p-10" data-testid="philosophy-coaching-isnt">
            <p className="text-xs uppercase tracking-widest text-sunlit-mute font-medium mb-4">
              What it is NOT
            </p>
            <ul className="space-y-4">
              {[
                "Therapy or clinical counselling",
                "A diagnosis or a prescription",
                "Someone fixing you from the outside",
                "A quick fix without your participation",
              ].map((t) => (
                <li key={t} className="flex items-start gap-3 text-sunlit-mute">
                  <span className="mt-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-stone-200">
                    <X className="h-3 w-3 text-stone-500" strokeWidth={3} />
                  </span>
                  <span className="text-base">{t}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
